export enum Messenger {
    Telegram = 'telegram',
    Viber = 'viber',
    Whatsapp = 'whatsapp',
}
